export default __webpack_public_path__ + "static/media/footer.d4e6df6a.svg";